module.exports = __webpack_public_path__ + "static/media/account-backyard.40abe2ce.png";